import {
  ChildFilterValue,
  FilterBuild,
  FilterBuildItemValue
} from '@components/collection/CollectionFilter/FiltersSidePanel/types'
import { BUILD } from '@consts/index'
import { objectKeys } from '@helpers/utils'
import { FilterOption } from 'types/filters'

function getDefaultValues(
  values: FilterBuildItemValue[],
  filterOptions: FilterOption[],
  type: string
): FilterBuildItemValue[] {
  return values.map(item => {
    const isSelected = filterOptions.some(
      filter =>
        filter.type === type &&
        filter.value.replace(BUILD, '').trim() ===
          (item as ChildFilterValue).value.replace(BUILD, '').trim()
    )

    if ('values' in item) {
      return {
        ...item,
        active: true,
        selected: isSelected,
        selectedChildCount: item.values.filter(child => child.selected).length
      }
    }
    return { ...item, active: true, selected: isSelected }
  })
}

export function updateFilterBuild(
  filterBuild: FilterBuild,
  filterOptions: FilterOption[]
) {
  if (!filterBuild) {
    return filterBuild
  }

  return filterBuild.map(filter => {
    const childCounts: Record<string, number> = {}

    const updatedValues = filter.values.map(value => {
      const updatedChildren =
        'values' in value
          ? getDefaultValues(value.values, filterOptions, value.path)
          : []

      const selectedChildCount = updatedChildren.filter(v => v.selected).length

      if (selectedChildCount > 0) {
        childCounts[filter.path] =
          (childCounts[filter.path] || 0) + selectedChildCount
      }

      return { ...value, values: updatedChildren, selectedChildCount }
    })
    return {
      ...filter,
      values: updatedValues,
      selectedChildCount: objectKeys(childCounts).length
        ? childCounts[filter.path]
        : 0
    }
  })
}
